export default {
  f843939e3689bdd3f19f9546ad57d04c: 'Please select the available coupons',
  a0ecec5b6e3c8bd5219bfa6651c495dd: 'No available coupons',
  '35d266578bfc5804668c799e07c7a47e': 'No available vouchers',
  aa9b2436d91ba608dd82d616b6a564b9: 'Please select the available vouchers',
  aa57cab48b8dd60903b3f215a35f8bd2: 'Commodity price',
  '5a5cc12eeef86e20f511c5e9c749b5f6': 'Discount amount',
  e524e2c0fcb17d7b2b1c58becc73cde1: 'Coupon',
  '3d8680f7ff1d0bb9c764d68cf70dfb3e': 'Voucher',
  d55e93e26c8639a968b3da4b11ec1cac: 'Discount applied',
  a59d355d26a255a6210028b4f7385f0f: 'Total',
  fac3670cf24e7bebc5fa8a4fd98c6f8f: 'Signing price'
};
